import instance from "../apis/axiosConfig";

// CREATE
export const createMarquee = (data) =>
  instance.post("marqueeSettings/create", data);

// GET 
export const getMarquee = () =>
  instance.get("marqueeSettings/getAll");

// UPDATE
export const updateMarquee = (id, data) =>
  instance.post(`marqueeSettings/update/${id}`, data);

// DELETE 
export const deleteMarquee = (id) =>
  instance.delete(`marqueeSettings/delete/${id}`);

// PUBLISH STATUS
export const updateMarqueePublishStatus = (id, data) =>
  instance.post(`marqueeSettings/update-publish-status/${id}`, data);